import { render, staticRenderFns } from "./inspect-quality.vue?vue&type=template&id=0164c89b&scoped=true"
import script from "./inspect-quality.vue?vue&type=script&lang=js"
export * from "./inspect-quality.vue?vue&type=script&lang=js"
import style0 from "./inspect-quality.vue?vue&type=style&index=0&id=0164c89b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0164c89b",
  null
  
)

export default component.exports